<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script type="text/javascript">
document.write(
  unescape(
    "%3Cspan id='cnzz_stat_icon_1279231650'%3E%3C/span%3E%3Cscript src='https://s4.cnzz.com/z_stat.php%3Fid%3D1279231650%26show%3Dpic2' type='text/javascript'%3E%3C/script%3E"
  )
);
document.body.scrollTop = 0;
</script>
<style>
@import "./assets/css/index.css";
#cnzz_stat_icon_1279231650 {
  display: none;
}
</style>


